import { useMutation } from '@apollo/client/react';
import { UPDATE_INVOICE_DELIVERY_MUTATION } from '../../integrations/allkort/graphql/gql/CustomerMutations';
import {
    InvoiceMailingDeliveryType,
    UpdateInvoiceDeliveryInput,
    UpdateInvoiceDeliveryResponse,
} from '../../integrations/allkort/graphql/interface/CustomerMutation';

export { InvoiceMailingDeliveryType };

/**
 * useUpdateInvoiceDelivery
 *
 * Custom hook for updating the customer's invoice (faktura) mailing delivery type.
 *
 * @example
 * ```tsx
 * const { updateInvoiceDelivery, loading, error, data } = useUpdateInvoiceDelivery();
 *
 * await updateInvoiceDelivery({
 *   customerId: 442603,
 *   deliveryType: InvoiceMailingDeliveryType.EMAIL_DISPATCH,
 * });
 * ```
 */
export const useUpdateInvoiceDelivery = () => {
	const [updateInvoiceDeliveryMutation, { loading, error, data }] = useMutation<
		UpdateInvoiceDeliveryResponse,
		UpdateInvoiceDeliveryInput
	>(UPDATE_INVOICE_DELIVERY_MUTATION, { errorPolicy: 'all' });

	const updateInvoiceDelivery = async (input: UpdateInvoiceDeliveryInput) => {
		return updateInvoiceDeliveryMutation({
			variables: {
				customerId: input.customerId,
				deliveryType: input.deliveryType,
			},
		});
	};

	return { updateInvoiceDelivery, loading, error, data };
};
